var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"status-badge",style:({
    backgroundColor: _vm.resolvedColor,
    color: _vm.contrastTextColor,
  })},[_vm._v(" "+_vm._s(_vm.resolvedName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }